import { writable } from 'svelte/store';
import type { IUser } from 'garden-common';

export const userUpdate = writable<boolean>(null);
export const userData = writable<IUser<string>[]>([]);
export const me = writable<IUser<string>>(null);
export const profileSelectedTab = writable<
  'posts' | 'gallery' | 'supporters' | 'contributions' | 'about' | 'seed-wallet'
>('posts');
